var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_4311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 31C66 24.8688 64.1819 18.8753 60.7756 13.7773C57.3692 8.67941 52.5277 4.70606 46.8632 2.35975C41.1987 0.0134318 34.9656 -0.600471 28.9522 0.59567C22.9388 1.79181 17.4151 4.74428 13.0797 9.0797C8.74428 13.4151 5.79181 18.9388 4.59567 24.9522C3.39953 30.9656 4.01343 37.1987 6.35975 42.8632C8.70606 48.5277 12.6794 53.3692 17.7773 56.7756C22.8753 60.1819 28.8688 62 35 62C43.2189 61.9909 51.0986 58.7219 56.9102 52.9102C62.7219 47.0986 65.9909 39.2189 66 31ZM32.8083 45.5917C32.5204 45.3039 32.292 44.9622 32.1361 44.5862C31.9803 44.2101 31.9001 43.807 31.9001 43.3999C31.9001 42.9928 31.9803 42.5897 32.1361 42.2137C32.292 41.8376 32.5204 41.4959 32.8083 41.2081L39.9164 34.1H22.6C21.7778 34.1 20.9893 33.7734 20.408 33.192C19.8266 32.6107 19.5 31.8222 19.5 31C19.5 30.1778 19.8266 29.3893 20.408 28.808C20.9893 28.2266 21.7778 27.9 22.6 27.9H39.9164L32.8083 20.7917C32.2357 20.2086 31.9165 19.423 31.9202 18.6058C31.9239 17.7886 32.2502 17.0059 32.8281 16.4281C33.4059 15.8502 34.1886 15.5239 35.0058 15.5202C35.823 15.5165 36.6086 15.8357 37.1917 16.4083L49.5908 28.8074C50.1699 29.3902 50.4949 30.1785 50.4949 31.0001C50.4949 31.8217 50.1699 32.61 49.5908 33.1929L37.1917 45.5917C36.9039 45.8796 36.5623 46.108 36.1862 46.2638C35.8101 46.4196 35.4071 46.4998 35 46.4998C34.5929 46.4998 34.1899 46.4196 33.8138 46.2638C33.4378 46.108 33.0961 45.8796 32.8083 45.5917Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_4311",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_4311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_4311",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f5ea1fe7a39d24bda3755ae512feae70.svg";
export { ForwardRef as ReactComponent };